import {
  AI_OPERATIONS_MANAGER_SENDER_NAME,
  AI_OPERATIONS_MANAGER_SOLUTION_KEY,
  AI_OPERATIONS_MANAGER_SOLUTION_NAME,
  AI_OPERATIONS_MANAGER_THREAD_HINT,
} from './aiOperationsManagerConfig';
import {
  AI_PROPOSAL_MANAGER_SENDER_NAME,
  AI_PROPOSAL_MANAGER_SOLUTION_KEY,
  AI_PROPOSAL_MANAGER_SOLUTION_NAME,
  AI_PROPOSAL_MANAGER_THREAD_HINT,
} from './aiProposalManagerConfig';

export interface SpecialisedAiParticipantOption {
  endpoint: string;
  solutionKey: string;
  solutionName: string;
  senderName: string;
  threadHint: string;
  activeThreadLabel: string;
  threadMessagePlaceholder: string;
  defaultPrompt: string;
  promptPlaceholder: string;
  successPreviewMessage: string;
  successPostedMessage: string;
  errorLabel: string;
}

export const AI_OPERATIONS_PARTICIPANT_OPTION: SpecialisedAiParticipantOption = {
  endpoint: '/api/v1/operations/ai-thread-participant',
  solutionKey: AI_OPERATIONS_MANAGER_SOLUTION_KEY,
  solutionName: AI_OPERATIONS_MANAGER_SOLUTION_NAME,
  senderName: AI_OPERATIONS_MANAGER_SENDER_NAME,
  threadHint: AI_OPERATIONS_MANAGER_THREAD_HINT,
  activeThreadLabel: 'AI Ops participant active',
  threadMessagePlaceholder: 'Message the team — AI Ops replies automatically in this thread',
  defaultPrompt: 'Summarise the highest-risk appointment in this thread and recommend the next manager action.',
  promptPlaceholder: 'Ask the AI Operations participant what you want it to answer in-thread',
  successPreviewMessage: 'AI Operations preview generated',
  successPostedMessage: 'AI Operations reply posted to the thread',
  errorLabel: 'the AI Operations participant',
};

export const AI_PROPOSAL_PARTICIPANT_OPTION: SpecialisedAiParticipantOption = {
  endpoint: '/api/v1/operations/ai-proposal-thread-participant',
  solutionKey: AI_PROPOSAL_MANAGER_SOLUTION_KEY,
  solutionName: AI_PROPOSAL_MANAGER_SOLUTION_NAME,
  senderName: AI_PROPOSAL_MANAGER_SENDER_NAME,
  threadHint: AI_PROPOSAL_MANAGER_THREAD_HINT,
  activeThreadLabel: 'AI Proposal participant active',
  threadMessagePlaceholder: 'Message the team — AI Proposal replies automatically in this thread',
  defaultPrompt: 'Draft a concise proposal summary for this thread and highlight the strongest commercial next step.',
  promptPlaceholder: 'Ask the AI Proposal participant what you want it to answer in-thread',
  successPreviewMessage: 'AI Proposal preview generated',
  successPostedMessage: 'AI Proposal reply posted to the thread',
  errorLabel: 'the AI Proposal participant',
};

export const SPECIALISED_AI_PARTICIPANT_OPTIONS: SpecialisedAiParticipantOption[] = [
  AI_OPERATIONS_PARTICIPANT_OPTION,
  AI_PROPOSAL_PARTICIPANT_OPTION,
];

export const DEFAULT_SPECIALISED_AI_PARTICIPANT_OPTION = AI_OPERATIONS_PARTICIPANT_OPTION;

export const SHARED_THREAD_SOLUTION_KEY_DOC_EXAMPLE = SPECIALISED_AI_PARTICIPANT_OPTIONS
  .map((option) => option.solutionKey)
  .join(' or ');

export function getSpecialisedAiParticipantOption(solutionKey?: string | null): SpecialisedAiParticipantOption {
  const normalizedSolutionKey = typeof solutionKey === 'string'
    ? solutionKey.trim().toLowerCase()
    : '';

  return SPECIALISED_AI_PARTICIPANT_OPTIONS.find((option) => option.solutionKey === normalizedSolutionKey)
    || DEFAULT_SPECIALISED_AI_PARTICIPANT_OPTION;
}
